import type { FC } from "react"

import { CheckIcon } from "@radix-ui/react-icons"

import styles from "./FlagCheckbox.module.scss"

type FlagCheckboxProps = {
	checked: boolean
	indeterminate?: boolean
	onChange: () => void
	size?: "small" | "normal"
}

const SIZE_CONFIG = {
	small: { iconSize: 12, baseClass: styles.checkboxSmall },
	normal: { iconSize: 14, baseClass: styles.checkbox },
}

const FlagCheckbox: FC<FlagCheckboxProps> = ({
	checked,
	indeterminate,
	onChange,
	size = "normal",
}) => {
	const { iconSize, baseClass } = SIZE_CONFIG[size]
	const isActive = checked || indeterminate
	const classes = [baseClass]
	if (isActive) classes.push(styles.checkboxActive)

	return (
		<button className={classes.join(" ")} onClick={onChange} type="button">
			{checked && <CheckIcon width={iconSize} height={iconSize} />}
			{indeterminate && !checked && <span className={styles.indeterminate} />}
		</button>
	)
}

export default FlagCheckbox
